import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../layout/Footer/Footer';
import Header from '../../layout/Header/Header';
import ScrollToTop from '../../Shared/ScrollToTop';

import Portfolio from './Components/Portfolio'

import bg from '../../../images/banner/navBarImage.png';
import { useTranslation } from "react-i18next";

import './Reference.css';
import Aos from "aos";

const References = ({ lang, SetLang }) => {

    const [t, i18n] = useTranslation('traduction');

    useEffect(() => {
        Aos.init({
            duration: 1500,
            disable: 'mobile',
            once: true,
            mirror: false
        });
        i18n.changeLanguage(lang);
    }, [i18n, lang]);

    return (
        <>
            <Header lang={lang} SetLang={SetLang} />
            <div class="page-content bg-white">
                <div class="dlab-bnr-inr overlay-black-middle bg-pt" style={{ backgroundImage: "url(" + bg + ")" }} >
                    <div class="container">
                        <div class="dlab-bnr-inr-entry">
                            <h1 class="text-white">{t('Nos Références')}</h1>
                            <div class="breadcrumb-row">
                                <ul class="list-inline">
                                    <li><Link to="/">{t('Accueil')}</Link></li>
                                    <li>{t('Nos Références')}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <Portfolio lang={lang} SetLang={SetLang} col="col-md-4" />

            </div>
            <Footer lang={lang} SetLang={SetLang} />
            <ScrollToTop className="scroltop style2 radius " />

        </>
    )
}
export default References;